"use client";
import e from "styled-components";
const t = e.div.attrs({
  className: "bl-container bl-container--small bl-m-y-4"
})`
  & > div {
    
    select {
      padding-right: 2.5rem;
    }

    & > * {
      padding-right: 0.5rem;
    }

    .bl-select > label {
      white-space: nowrap;
    }
  }
`;
export {
  t as default
};
//# sourceMappingURL=index.es173.js.map
